import React, { useEffect, useState } from "react";
import DefaultTextBold from "../../../../../../../components/Accessibility/DefaultTextBold";
import DefaultTable from "../../../../../../../components/Accessibility/DefaultTable";
import TableBold from "../../../../../../../components/Accessibility/DefaultTable/TableBold";
import TableRegular from "../../../../../../../components/Accessibility/DefaultTable/TableRegular";
import { getBenef } from "../../../../../../../Store/storages/BeneficiarioStorage";
import "../../../../styles.css";
import { useAccessibility } from "../../../../../../../Store/contexts/AccessibilityContext";
import DefaultButton from "../../../../../../../components/Accessibility/DefaultButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import ContatoModal from "../ContatoModal";
import ConfirmacaoModal from "../ConfirmacaoModal";
import { useGestaoDeCronicosCaptacao } from "../../../../context/CaptacaoContext";

export const ConfirmeSeusDados = () => {
  const { textStyleAccessibility, contrastStyle } = useAccessibility();
  const {
    hourSelected,
    showConfirmacaoModal,
    setShowConfirmacaoModal,
    chronicScheduling,
  } = useGestaoDeCronicosCaptacao();
  const [showContatoModal, setShowContatoModal] = useState<boolean>(false);
  const [userData, setUserData] = useState<{
    tel: string;
    cel: string;
    email: string;
  } | null>(null);

  useEffect(() => {
    setUserData(getBenef());
  }, []);

  const formatDate = () => {
    if (!hourSelected) {
      return "";
    }

    const [date, time] = hourSelected.split(" ");
    const formattedDateTime = `${date} às ${time}h`;

    return formattedDateTime;
  };

  const dataContato = [
    [
      <TableBold text="Telefone" />,
      <TableRegular text={userData?.tel || "(19) 99999-9999"} />,
    ],
    [
      <TableBold text="Celular" />,
      <TableRegular text={userData?.cel || "(19) 99999-9999"} />,
    ],
    [
      <TableBold text="Email" />,
      <TableRegular text={userData?.email || "exemplo@gmail.com"} />,
    ],
  ];

  const handleCancelarAtualizarContato = () => {
    setShowContatoModal(false);
  };

  const handleAtualizarContato = ({
    tel,
    cel,
    email,
  }: {
    tel: string;
    cel: string;
    email: string;
  }) => {
    setUserData({
      tel,
      cel,
      email,
    });
    setShowContatoModal(false);
  };

  return (
    <div className="content-container">
      <h1 className="gestao-de-cronicos-title" style={textStyleAccessibility}>
        Agendar consulta
      </h1>
      <DefaultTextBold text="Confirme seus dados de contato" />
      <DefaultTable
        data={dataContato}
        headers={["Dados de contato"]}
        columnWidths={["50%", "50%"]}
      />
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          background: "#fff",
        }}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setShowContatoModal(true);
          }
        }}
      >
        <div>
          <FontAwesomeIcon
            icon={faEdit}
            color="#00834F"
            style={contrastStyle}
          />
        </div>
        <div>
          <button
            tabIndex={-1}
            className="editar-contato-button"
            onClick={() => setShowContatoModal(true)}
            style={contrastStyle}
          >
            Alterar dados de contato
          </button>
        </div>
      </div>
      <DefaultButton
        className="button-questionnaire-detail"
        text="Confirmar"
        onClick={() => {
          chronicScheduling(userData);
          setShowConfirmacaoModal(true);
        }}
      />
      <ContatoModal
        userData={userData || { cel: "", tel: "", email: "" }}
        showModal={showContatoModal}
        handleCancelarClick={handleCancelarAtualizarContato}
        handleSalvarClick={handleAtualizarContato}
      />

      <ConfirmacaoModal
        showModal={showConfirmacaoModal}
        setShowConfirmacaoModal={setShowConfirmacaoModal}
        dateHour={formatDate}
      />
    </div>
  );
};
